import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { base_url } from "../context/Authcontext";
import '../../src/assets/AdminCss/card.css';


const formatDate = (dateString) => {
  if (!dateString) return null;

  const dateObj = new Date(dateString);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`; // Only date (YYYY-MM-DD)
};

const compareWithToday = (eventDate, allEvents) => {
  const now = new Date();
  const eventDateObj = new Date(eventDate);

  // Convert both to local date strings (YYYY-MM-DD) for comparison
  const todayDate = now.toISOString().split("T")[0];
  const eventDateFormatted = eventDateObj.toISOString().split("T")[0];

  // Get time in minutes since midnight
  const currentMinutes = getMinutesSinceMidnight(now);
  const eventMinutes = getMinutesSinceMidnight(eventDateObj);

  // Calculate 7 hours ago in minutes
  const sevenHoursAgo = currentMinutes - 420; // 7 * 60 minutes

  // Ensure the event is today
  if (todayDate !== eventDateFormatted) {
    return false;
  }

  // Return true if the event is within the range from 7 hours ago to the end of today
  return eventMinutes >= sevenHoursAgo;
};

const getMinutesSinceMidnight = (date) => {
  return date.getUTCHours() * 60 + date.getUTCMinutes(); // Ensures UTC time handling
};



const Inplay = ({ data }) => {
  const navigate= useNavigate();
  const [cricket, setCricket]= useState([]);
  const [avail, setAvail]= useState([]);
  const [loading, setLoading] = useState(true);


  const tennisData = async () => {
 
    try {
      const response = await axios.get(
        base_url + '/api/webapi/tennisapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (compareWithToday(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
  const fetchData = async () => {
    if (data === 0) {
      await tennisData();  // assume this sets cricket state internally
    }
  };
  fetchData();
}, [data]);


  useEffect(()=>{
    const oddsData= async(req, res)=> {
      let marketid=[];

      try{

        if (!Array.isArray(cricket) || cricket.length === 0) {
          // console.log(cricket.length);
          return;
        }

        for (let item of cricket){

          marketid.push(item.marketId);
        }
        // console.log(marketid);


        const response= await axios.post(base_url + `/api/webapi/market/wholeMarket`,
          marketid,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )

        // console.log('marketid',JSON.parse(response.data));
        const result= JSON.parse(response.data);

        // console.log(result);
        setAvail(result);


      }catch(err){
        console.log(err);
      }
    }

    oddsData();
  },[cricket]);

  // console.log('vall',cricket);
  // console.log(avail);
  // console.log(avail);

  const handleClick= (item)=>{
    // console.log(item);

    sessionStorage.setItem('marketId', item.marketId);
    sessionStorage.setItem('competetionid', item.competition.id);
    sessionStorage.setItem('eventid', item.event.id);
    sessionStorage.setItem('time',item?.event.openDate);
    sessionStorage.setItem('competitionname',item?.competition.name);
    sessionStorage.setItem('eventname',item?.event.name);

  if(item.eventType.name==="Tennis"){
    navigate('/tennis');
    sessionStorage.setItem('selectionid1',item?.runners[0].selectionId);
    sessionStorage.setItem('selectionid2',item?.runners[1].selectionId);

    sessionStorage.setItem('runner1', item.runners[0].runnerName);
    sessionStorage.setItem('runner2', item.runners[1].runnerName);
  }
  }

  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" className="sports-wrapper">

              {cricket?.length > 0 ? (
                  cricket.filter(
                    (item) =>
                      avail[item.marketId] &&
                      avail[item.marketId]?.length > 0 &&
                      avail[item.marketId].some(
                        (market) =>
                          (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];
                    // console.log('arrAnsu',marketData);

                    return (
                      <div
                        key={index}
                        _ngcontent-jrx-c94=""
                        id={item?.competitionId}
                        className="col-12 ng-star-inserted"
                        style={{ position: "relative" }}
                      >
                        <span className="text-black fszz">{new Date(item?.event.openDate).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="text-black fszz">Today</span>
                          {/* <p>{item.marketId}</p> */}
                        <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                          >
                          <div
                            _ngcontent-jrx-c94=""
                            className="section_details_box upcoming-data"
                          >
                            {/* {item.isStarted && (
                              <span
                                _ngcontent-jrx-c94=""
                                className="innerHTMLScore upcoming-score ng-star-inserted"
                              >
                                <div className="cricket-info">
                                  <div className="score" 
                                  >
                                    <span>
                                      {item.title1}
                                      <span className="vOver">(45.0)</span>
                                    </span>
                                    <span className="vRun">
                                      0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                    </span>
                                    <span>
                                      {item.title2}
                                      <span className="vOver">(0.0)</span>
                                    </span>
                                  </div>
                                </div>
                              </span>
                            )} */}
                            
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-type-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="runnners-odds-details"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-name-wrapper"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_box_team"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_box_t_name t_left fs-4"
                                      onClick={()=>handleClick(item)}
                                    >
                                      {" "}
                                      {item.runners[0].runnerName}{" "}
                                      <span
                                        _ngcontent-jrx-c94=""
                                        className="vs ng-star-inserted"
                                      >
                                        {" "}
                                        vs{" "}
                                      </span>
                                      {item.runners[1]?.runnerName}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="middle-detail"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className={`${
                                      item.isStarted
                                        ? "green-circle inplay-blinker ng-star-inserted"
                                        : ""
                                    }`}
                                  ></div>
                                  <img
                                    _ngcontent-jrx-c94=""
                                    className="small-grid ng-star-inserted"
                                    style={{ height: "10px" }}
                                    src="/assets/images/tv.svg"
                                    alt="TVKheloyaar360"
                                  />
                                
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid"
                                  >
                                    <span _ngcontent-jrx-c94=""> BM</span>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                  style={{ position: "relative" }}
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_small_boxes_let responsive-width-sports-all"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_small_boxes_inn ng-star-inserted"
                                      >

                          {marketData && marketData.length > 0 ? (
                                        <div className="d-flex runnners-odds-details gap-1">
                                          {(() => {
                                            let backDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToBack?.length > 0
                                                ? [{ price: market.ex.availableToBack[0].price, type: "Back" }]
                                                : []
                                            );
                                            let layDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToLay?.length > 0
                                                ? [{ price: market.ex.availableToLay[0].price, type: "Lay" }]
                                                : []
                                            );
                                            
                                            // Fill up with empty divs if needed to ensure 6 elements
                                            while (backDivs.length < 2) backDivs.push({ price: null, type: "Back" });
                                            while (layDivs.length < 2) layDivs.push({ price: null, type: "Lay" });

                                            let combinedDivs = [
                                              backDivs[0],
                                              layDivs[0],
                                              { price: null, type: "Back" }, // Empty Back
                                              { price: null, type: "Lay" }, // Empty Lay
                                              backDivs[1],
                                              layDivs[1],
                                            ];

                                            return combinedDivs.map((item, index) => (
                                              <app-oddsbutton key={index}>
                                                <div
                                                  id={index}
                                                  className={`d-md-flex ${
                                                    item.type === "Lay" ? "bg-pink1" : ""
                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                  
                                                >
                                                  <span className="ng-star-inserted">
                                                    {item.price !== null ? item.price : "--"}
                                                  </span>
                                                </div>
                                              </app-oddsbutton>
                                            ));
                                          })()}
                                        </div>
                                      ): (
                          <div>No matches found.</div>
                        )}
                                      </div>
                                    </div>
                                    <div
                                      _ngcontent-jrx-c94=""
                                      style={{ clear: "both" }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>No Matches Found.</div>
                )}

               
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const Tomorrow = ({ data }) => {
  const navigate= useNavigate();
  const [cricket, setCricket]= useState([]);
  const [avail, setAvail]= useState();
  let allData = [];
  
  const isTomorrow = (eventDate) => {
    const now = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(now.getDate() + 1); // Get tomorrow's date
  
    const tomorrowFormatted = formatDate(tomorrow);
    const eventFormatted = formatDate(eventDate);
  
    // console.log("Tomorrow's Date:", tomorrowFormatted);
    // console.log("Event Date:", eventFormatted);
  
    return tomorrowFormatted === eventFormatted; // Compare only dates
  };


  const tennisData = async () => {
 
    try {
      const response = await axios.get(
        base_url + '/api/webapi/tennisapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (isTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };



  useEffect(() => {
  const fetchData = async () => {
    if (data === 0) {
      await tennisData();  // assume this sets cricket state internally
    }
  };
  fetchData();
}, [data]);


  useEffect(()=>{
    const oddsData= async(req, res)=> {
      let marketid=[];

      try{

        if (!Array.isArray(cricket) || cricket.length === 0) {
          // console.log(cricket.length);
          return;
        }

        for (let item of cricket){

          marketid.push(item.marketId);
        }
        // console.log(marketid);


        const response= await axios.post(base_url + `/api/webapi/market/wholeMarket`,
          marketid,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )

        // console.log('marketid',JSON.parse(response.data));
        const result= JSON.parse(response.data);

        // console.log(result);
        setAvail(result);


      }catch(err){
        console.log(err);
      }
    }

    oddsData();
  },[cricket]);
//   console.log(cricket);



  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" >
              {cricket?.length > 0 ? (
                  cricket.filter((item) => {
                    const marketArr = avail?.[item.marketId];
                    if (!Array.isArray(marketArr) || marketArr.length === 0) return false;

                    return marketArr.some(
                      (market) =>
                        market?.ex?.availableToBack?.length > 0 ||
                        market?.ex?.availableToLay?.length > 0
                    );
                  })
                  .map((item, index) => {
                    const marketData = avail[item.marketId] || [];
                    // console.log('arrAnsu',marketData);


                    return (
                      <div
                        key={index}
                        _ngcontent-jrx-c94=""
                        id={item?.competitionId}
                        className="col-12 ng-star-inserted"
                        style={{ position: "relative" }}
                      >
                        <span className="text-black fszz">{new Date(item?.event.openDate).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="text-black fszz">Tomorrow</span>
                          {/* <p>{item.marketId}</p> */}
                        <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                          >
                          <div
                            _ngcontent-jrx-c94=""
                            className="section_details_box upcoming-data"
                          >
                            {/* {item.isStarted && (
                              <span
                                _ngcontent-jrx-c94=""
                                className="innerHTMLScore upcoming-score ng-star-inserted"
                              >
                                <div className="cricket-info">
                                  <div className="score" 
                                  >
                                    <span>
                                      {item.title1}
                                      <span className="vOver">(45.0)</span>
                                    </span>
                                    <span className="vRun">
                                      0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                    </span>
                                    <span>
                                      {item.title2}
                                      <span className="vOver">(0.0)</span>
                                    </span>
                                  </div>
                                </div>
                              </span>
                            )} */}
                            
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-type-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="runnners-odds-details"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-name-wrapper"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_box_team"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_box_t_name t_left fs-4"
                                      onClick={()=>navigate('/tennis',
                                        sessionStorage.setItem('marketId', item.marketId),
                                        sessionStorage.setItem('competetionid', item.competition.id),
                                        sessionStorage.setItem('eventid', item.event.id),
                                        sessionStorage.setItem('time',item?.event.openDate),
                                        sessionStorage.setItem('competitionname',item?.competition.name),
                                        sessionStorage.setItem('eventname',item?.event.name),
                                        sessionStorage.setItem('selectionid1',item?.runners[0].selectionId),
                                        sessionStorage.setItem('selectionid2',item?.runners[1].selectionId),

                                        sessionStorage.setItem('runner1', item.runners[0].runnerName),
                                        sessionStorage.setItem('runner2', item.runners[1].runnerName),
                                      { state: { marketId: item.marketId, runner1: item.runners[0].runnerName, runner2: item.runners[1].runnerName } })}
                                    >
                                      {" "}
                                      {item.runners[0].runnerName}{" "}
                                      <span
                                        _ngcontent-jrx-c94=""
                                        className="vs ng-star-inserted"
                                      >
                                        {" "}
                                        vs{" "}
                                      </span>
                                      {item.runners[1]?.runnerName}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="middle-detail"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className={`${
                                      item.isStarted
                                        ? "green-circle inplay-blinker ng-star-inserted"
                                        : ""
                                    }`}
                                  ></div>
                                  <img
                                    _ngcontent-jrx-c94=""
                                    className="small-grid ng-star-inserted"
                                    style={{ height: "10px" }}
                                    src="/assets/images/tv.svg"
                                    alt="TVKheloyaar360"
                                  />
                                
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid"
                                  >
                                    <span _ngcontent-jrx-c94=""> BM</span>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                  style={{ position: "relative" }}
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_small_boxes_let responsive-width-sports-all"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_small_boxes_inn ng-star-inserted"
                                      >

                          {marketData && marketData.length > 0 ? (
                                        <div className="d-flex runnners-odds-details gap-1">
                                          {(() => {
                                            let backDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToBack?.length > 0
                                                ? [{ price: market.ex.availableToBack[0].price, type: "Back" }]
                                                : []
                                            );
                                            let layDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToLay?.length > 0
                                                ? [{ price: market.ex.availableToLay[0].price, type: "Lay" }]
                                                : []
                                            );
                                            
                                            // Fill up with empty divs if needed to ensure 6 elements
                                            while (backDivs.length < 2) backDivs.push({ price: null, type: "Back" });
                                            while (layDivs.length < 2) layDivs.push({ price: null, type: "Lay" });

                                            let combinedDivs = [
                                              backDivs[0],
                                              layDivs[0],
                                              { price: null, type: "Back" }, // Empty Back
                                              { price: null, type: "Lay" }, // Empty Lay
                                              backDivs[1],
                                              layDivs[1],
                                            ];

                                            return combinedDivs.map((item, index) => (
                                              <app-oddsbutton key={index}>
                                                <div
                                                  id={index}
                                                  className={`d-md-flex ${
                                                    item.type === "Lay" ? "bg-pink1" : ""
                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                  
                                                >
                                                  <span className="ng-star-inserted">
                                                    {item.price !== null ? item.price : "--"}
                                                  </span>
                                                </div>
                                              </app-oddsbutton>
                                            ));
                                          })()}
                                        </div>
                                      ): (
                          <div>No matches found.</div>
                        )}
                                      </div>
                                    </div>
                                    <div
                                      _ngcontent-jrx-c94=""
                                      style={{ clear: "both" }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>No Matches Found.</div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const Upcoming = ({ data }) => {
  const navigate=useNavigate();

  const [cricket, setCricket]= useState([]);
  const [avail, setAvail]= useState([]);


  const isAfterTomorrow = (eventDate) => {
    const now = new Date();
    const afterTomorrow = new Date();
    afterTomorrow.setDate(now.getDate() + 2); // Get the day after tomorrow
  
    const eventFormatted = formatDate(eventDate);
    const afterTomorrowFormatted = formatDate(afterTomorrow);
    // console.log('afterr',afterTomorrowFormatted);
    
    return eventFormatted >= afterTomorrowFormatted; // Checks if event is after tomorrow
  };

  const tennisData = async () => {
 
    try {
      const response = await axios.get(
        base_url + '/api/webapi/tennisapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };


  useEffect(() => {
  const fetchData = async () => {
    if (data === 0) {
      await tennisData();  // assume this sets cricket state internally
    }
  };
  fetchData();
}, [data]);


  useEffect(()=>{
    const oddsData= async(req, res)=> {
      let marketid=[];

      try{

        if (!Array.isArray(cricket) || cricket.length === 0) {
          // console.log(cricket.length);
          return;
        }

        for (let item of cricket){

          marketid.push(item.marketId);
        }
        // console.log(marketid);


        const response= await axios.post(base_url + `/api/webapi/market/wholeMarket`,
          marketid,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )

        // console.log('marketid',JSON.parse(response.data));
        const result= JSON.parse(response.data);

        // console.log(result);
        setAvail(result);


      }catch(err){
        console.log(err);
      }
    }

    oddsData();
  },[cricket]);

  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" className="sports-wrapper">
              {cricket?.length > 0 ? (
                  cricket.filter(
                    (item) =>
                      avail[item.marketId] &&
                      avail[item.marketId]?.length > 0 &&
                      avail[item.marketId].some(
                        (market) =>
                          (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];
                    // console.log('arrAnsu',marketData);

                    return (
                      <div
                        key={index}
                        _ngcontent-jrx-c94=""
                        id={item?.competitionId}
                        className="col-12 ng-star-inserted"
                        style={{ position: "relative" }}
                      >
                        <span className="text-black fszz">{new Date(item?.event.openDate).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span>
                          {/* <p>{item.marketId}</p> */}
                        <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                          >
                          <div
                            _ngcontent-jrx-c94=""
                            className="section_details_box upcoming-data"
                          >
                            {/* {item.isStarted && (
                              <span
                                _ngcontent-jrx-c94=""
                                className="innerHTMLScore upcoming-score ng-star-inserted"
                              >
                                <div className="cricket-info">
                                  <div className="score" 
                                  >
                                    <span>
                                      {item.title1}
                                      <span className="vOver">(45.0)</span>
                                    </span>
                                    <span className="vRun">
                                      0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                    </span>
                                    <span>
                                      {item.title2}
                                      <span className="vOver">(0.0)</span>
                                    </span>
                                  </div>
                                </div>
                              </span>
                            )} */}
                            
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-type-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="runnners-odds-details"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-name-wrapper"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_box_team"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_box_t_name t_left fs-4"
                                      onClick={()=>navigate('/tennis',
                                        sessionStorage.setItem('marketId', item.marketId),
                                        sessionStorage.setItem('competetionid', item.competition.id),
                                        sessionStorage.setItem('eventid', item.event.id),
                                        sessionStorage.setItem('time',item?.event.openDate),
                                        sessionStorage.setItem('competitionname',item?.competition.name),
                                        sessionStorage.setItem('eventname',item?.event.name),
                                        sessionStorage.setItem('selectionid1',item?.runners[0].selectionId),
                                        sessionStorage.setItem('selectionid2',item?.runners[1].selectionId),

                                        sessionStorage.setItem('runner1', item.runners[0].runnerName),
                                        sessionStorage.setItem('runner2', item.runners[1].runnerName),
                                      { state: { marketId: item.marketId, runner1: item.runners[0].runnerName, runner2: item.runners[1].runnerName } })}
                                    >
                                      {" "}
                                      {item.runners[0].runnerName}{" "}
                                      <span
                                        _ngcontent-jrx-c94=""
                                        className="vs ng-star-inserted"
                                      >
                                        {" "}
                                        vs{" "}
                                      </span>
                                      {item.runners[1]?.runnerName}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="middle-detail"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className={`${
                                      item.isStarted
                                        ? "green-circle inplay-blinker ng-star-inserted"
                                        : ""
                                    }`}
                                  ></div>
                                  <img
                                    _ngcontent-jrx-c94=""
                                    className="small-grid ng-star-inserted"
                                    style={{ height: "10px" }}
                                    src="/assets/images/tv.svg"
                                    alt="TVKheloyaar360"
                                  />
                                
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid"
                                  >
                                    <span _ngcontent-jrx-c94=""> BM</span>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                  style={{ position: "relative" }}
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_small_boxes_let responsive-width-sports-all"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_small_boxes_inn ng-star-inserted"
                                      >

                          {marketData && marketData.length > 0 ? (
                                        <div className="d-flex runnners-odds-details gap-1">
                                          {(() => {
                                            let backDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToBack?.length > 0
                                                ? [{ price: market.ex.availableToBack[0].price, type: "Back" }]
                                                : []
                                            );
                                            let layDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToLay?.length > 0
                                                ? [{ price: market.ex.availableToLay[0].price, type: "Lay" }]
                                                : []
                                            );
                                            
                                            // Fill up with empty divs if needed to ensure 6 elements
                                            while (backDivs.length < 2) backDivs.push({ price: null, type: "Back" });
                                            while (layDivs.length < 2) layDivs.push({ price: null, type: "Lay" });

                                            let combinedDivs = [
                                              backDivs[0],
                                              layDivs[0],
                                              { price: null, type: "Back" }, // Empty Back
                                              { price: null, type: "Lay" }, // Empty Lay
                                              backDivs[1],
                                              layDivs[1],
                                            ];

                                            return combinedDivs.map((item, index) => (
                                              <app-oddsbutton key={index}>
                                                <div
                                                  id={index}
                                                  className={`d-md-flex ${
                                                    item.type === "Lay" ? "bg-pink1" : ""
                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                  
                                                >
                                                  <span className="ng-star-inserted">
                                                    {item.price !== null ? item.price : "--"}
                                                  </span>
                                                </div>
                                              </app-oddsbutton>
                                            ));
                                          })()}
                                        </div>
                                      ): (
                          <div>No matches found.</div>
                        )}
                                      </div>
                                    </div>
                                    <div
                                      _ngcontent-jrx-c94=""
                                      style={{ clear: "both" }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>No Matches Found.</div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const TennisReal = () => {
  const [isSidebar, setSidebar] = useState(false);
  const [isInplay, setInplay] = useState(true);
  const [isTomorrow, setTomorrow] = useState(false);
  const [isUpcoming, setUpcoming] = useState(false);
  const [isActive, setActiveLink] = useState(0);


  const handlePlay = (id) => {
    setInplay(false);
    setTomorrow(false);
    setUpcoming(false);

    if (id === "inplay") {
      setInplay(true);

    } else if (id === "tomorrow") {
      setTomorrow(true);

    } else {
      setUpcoming(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };
    handleResize();
  }, []);



  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16" >
      
      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "1100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >


                <Header isSidebar={isSidebar} setSidebar={setSidebar} />
                <div className="news-bar">
                    <marquee style={{ width: '100%' }}>
                        <p className="m-0 w-100">
                        👉IPL MONTH DHAMAKA OFFER..GET 3% REFILL BONUS ON EVERY DEPOSIT... USDT DEPOSIT OPTION IS ALSO AVAILABLE ON OUR SITE👈👈...TO CONFIRM DEPOSIT BRANCH NUMBER CONTACT HELPDESK NO +265899881378
                        </p>
                    </marquee>
                </div>              

                <app-upcoming
                  _ngcontent-jrx-c95=""
                  _nghost-jrx-c94=""
                  className="ng-star-inserted"
                >
                  <div _ngcontent-jrx-c94="" className="upcoming-container">
                    <div _ngcontent-jrx-c94="" className="upcoming">
                      <div _ngcontent-jrx-c94="" className="items">
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isInplay ? "active-bar" : ""}`}
                          onClick={() => handlePlay("inplay")}
                        >
                          Inplay
                        </span>
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isTomorrow ? "active-bar" : ""}`}
                          onClick={() => handlePlay("tomorrow")}
                        >
                          Tomorrow
                        </span>
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isUpcoming ? "active-bar" : ""}`}
                          onClick={() => handlePlay("upcoming")}
                        >
                          Upcoming
                        </span>
                      </div>
                      <div
                        _ngcontent-jrx-c94=""
                        routerlink="/sports"
                        className="view-all"
                        tabIndex="0"
                      >
                        <span _ngcontent-jrx-c94=""> See All → </span>
                      </div>
                    </div>
                  </div>
                  
                  {isInplay && <Inplay data={isActive} />}
                  {isTomorrow && <Tomorrow data={isActive} />}
                  {isUpcoming && <Upcoming data={isActive} />}
                </app-upcoming>
               

                
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
       

        <div className="slider-container"></div>
      </div>
    </app-root>
  );
};


export default TennisReal;